<template>
  <div class="burger" @click="vModel = !vModel" :class="vModel ? 'burger--active' : ''">
<!--  <div class="burger">-->
    <div class="burger__item burger__item-1"></div>
    <div class="burger__item burger__item-2"></div>
  </div>
</template>

<script>
import vModel from '@/mixins/vModel'

export default {
  mixins: [vModel]
}
</script>

<style lang="scss">
  .burger {
    height: 1.1rem;
    width: 3rem;
    position: relative;
    z-index: 9;
    transition: .2s ease-in-out;
    cursor: pointer;

    &:active {
      -webkit-tap-highlight-color: transparent;
    }

    &__item {
      width: 3rem;
      height: 2px;
      background: $color-green;
      position: absolute;
      left: 0;
      /*transition: .2s ease-in-out;*/
      border-radius: $border-radius;
    }

    &__item-1 {
      top: 0;
    }

    &__item-2 {
      bottom: 0;
    }

    &--active {
      height: 1.55rem;

      .burger__item {
        top: 50%!important;
      }

      .burger__item-1 {
        transform: rotate(45deg);
      }

      .burger__item-2 {
        transform: rotate(-45deg);
        bottom: unset;
      }
    }
  }
</style>
